import { connect } from 'react-redux';

import { getIncludedInGroups } from 'reducers';

import Reseller from './Reseller';
import AttUserSubs from '../UserSubs/att';

const mapStateToProps = (state) => ({
  UserSubs: AttUserSubs,
  isReseller: getIncludedInGroups(state, ['RESELLER']),
});

export default connect(mapStateToProps)(Reseller);
